import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button, Icon, Title, theme, Modal } from 'components';
import { makeModalResponsive } from 'utils';
import { useBreakpoint } from 'hooks';
import { AuthContext } from 'contexts';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from '../../AppointmentDeskContext';
import { StyledIconWrapper } from '../../StyledComponents';
import AnsweringServiceInfo from './AnsweringServiceInfo';
import ServiceLabels from '../../ServiceLabels';

const LegacyMyPlan: React.FC = () => {
  const { sm } = useBreakpoint();
  const { auth, onboarding } = useContext(AuthContext);
  const {
    subscriptionExists,
    subscriptionType,
    owner,
    answeringSubscription,
    portalConfig,
    currentStep,
  } = useContext(AppointmentDeskContext);

  const serviceInfo =
    auth?.org.onboardingPortalId &&
    (process.env.PORTAL_IDS_USING_SUPRA_CALL || '')
      .split(',')
      .includes(auth.org.onboardingPortalId)
      ? // TODO: This Timezone of CST should change if other timezoned MLS also
        // subscribes to Supra Call Center. Need Product team's work on wording change if that happens.
        'Live 7AM - 9PM CST service, 7 days a week'
      : '24 / 7 / 365 Live concierge service';
  const serviceLabels = [
    serviceInfo,
    'Incoming & outgoing calls to manage your listings',
    'Experienced & trained appointment specialists',
    subscriptionType === 'org'
      ? 'Full service experience'
      : 'Unlimited listings',
  ];

  const { setCurrentStep } = useContext(AppointmentDeskContext);
  return (
    <StyledPlanBody $sm={sm}>
      <StyledIconWrapper>
        <Icon type="antdPhoneFilled" color="info" />
      </StyledIconWrapper>
      <AnsweringServiceInfo />
      <ServiceLabels labels={serviceLabels} />
      <StyledSetupButton
        type="primary"
        onClick={() => {
          if (
            subscriptionType === 'org' &&
            (auth?.assumingUserId ||
              auth?.isAssumedNotBB ||
              auth?.assumerIdMlsStaff)
          ) {
            makeModalResponsive(
              Modal.error({
                title: 'You are not authorized to manage subscriptions.',
                content:
                  'You cannot manage subscriptions while assuming a user.',
                centered: true,
              }),
            );
            return;
          }
          setCurrentStep(AppointmentDeskStep.ManageListings);
        }}
        data-cy="setup-button"
      >
        Setup
      </StyledSetupButton>
    </StyledPlanBody>
  );
};

export default LegacyMyPlan;

const StyledPlanBody = styled.div<{ $sm: boolean }>`
  border: 1px solid ${theme.gray4};
  padding: 36px;
  width: ${({ $sm }) => ($sm ? 'max(480px, 40%)' : '100%')};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-top: 24px;
`;

const StyledSetupButton = styled(Button)`
  width: 100%;
  font-weight: 400;
`;
